<div *ngIf="rsp">
  <div style="display: flex;justify-content: center;">
    <div class="margin-auto login-form boxwrapper" style="margin-top: 10px;">
      <div class="stick-top">
        <mat-toolbar>
          <mat-icon>vpn_key</mat-icon>
          E-Mail Verification {{rsp.success ? 'Succeeded' : 'Failed'}}
        </mat-toolbar>
        <div class="hbox-nowrap lightly-padded button-bar">
          <a routerLink="/login" class="hbox-nowrap"><div><mat-icon>arrow_back</mat-icon></div> <div class="margin-auto">Go to Login Screen</div></a>
        </div>
      </div>

      <div class="login-title">{{env.config.appName}}</div>

      <div *ngIf="rsp.error">
        <mat-toolbar color="primary">
          :-( Something went wrong
        </mat-toolbar>
        <div class="padded">
          {{rsp.error}}
        </div>
      </div>
      <div *ngIf="!rsp.error && rsp.data">
        <div class="padded text-center">
          Thank you for verifying your E-Mail!<br/>
        </div>
      </div>
    </div>
  </div>
</div>


